

  import {defineComponent} from 'vue';

  import NavigatorComponent from '@/components/shared/NavigatorComponent.vue';
  import ProductListComponent from '@/components/productList/ProductListComponent.vue';
  import SortOptionComponent from '@/components/productList/SortOptionComponent.vue';
  import ToTopComponent from '@/components/shared/TopButtonComponent.vue';

  import HashTag from "@/domain/product/Hashtag";
  import api from "@/api/backend-api";
  import GetProductRequest from "@/domain/request/GetProductRequest";
  import Product from "@/domain/product/Product";
  import {SortOption} from "@/domain/sort/SortOption";
  import * as _ from "lodash";
  import {mapGetters, mapMutations} from "vuex";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import {NamedRouting} from "@/domain/utils/NamedRouting";

  export default defineComponent({
    name: 'ProductListView',
    components: {
      HeaderComponent,
      NavigatorComponent,
      SortOptionComponent,
      ProductListComponent,
      ToTopComponent
    },
    data() {
      return {
        page : 1,
        perPage: 20,
        hasMorePage: true as boolean,

        isLoading: false as boolean,
        debouncedScrollEvent: () => {return},

        hashtagList: new Array<HashTag>(
            new HashTag({id: -1, name: "전체", isSelected: true})
        ),
        indexOfSelectedHashtag: 0 as number,

        totalCount: 0 as number,
        products: [] as Array<Product>
      }
    },
    computed: {
      ...mapGetters('SortOptionStore', [
        'getSortOptionValue'
      ]),
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
    watch: {
      '$route'(after, before) {
        if (after.name != before.name) {
          return;
        }
        this.hashtagList[this.indexOfSelectedHashtag].isSelected = false;
        this.indexOfSelectedHashtag = this.$route.query.hashTag as unknown as number;
        this.hashtagList[this.indexOfSelectedHashtag].isSelected = true;
        this.loadNewProduct();
      }
    },
    created() {
      this.initSortOption(new Array<SortOption>(
          new SortOption("POPULARITY", "인기순", true),
          new SortOption("HIGH_PRICE", "고가순", false),
          new SortOption("LOW_PRICE", "저가순", false),
          new SortOption("NAME", "상품명순", false)
      ));
    },
    mounted() {
      api.getHashtagList()
      .then(response => {
        response.data.result.forEach(hashtag => {
          this.hashtagList.push(new HashTag(hashtag));
        });
        if(Object.keys(this.$route.query).length !== 0) {
          this.hashtagList[this.indexOfSelectedHashtag].isSelected = false;
          this.indexOfSelectedHashtag = this.$route.query.hashTag as unknown as number;
          this.hashtagList[this.indexOfSelectedHashtag].isSelected = true;
        }
        this.loadNewProduct();
      })
      .catch(error => {
        console.log("Error: " + error);
      });

      this.debouncedScrollEvent = _.debounce(this.infiniteScrollEvent, 100);
      window.addEventListener('scroll', this.debouncedScrollEvent);
    },
    beforeUnmount(): void {
      window.removeEventListener('scroll', this.debouncedScrollEvent);
    },
    methods: {
      infiniteScrollEvent(): void {
        const targetElement = document.getElementById("app");
        if (targetElement === undefined) {
          return;
        }

        if (this.products.length == 0) {
          return;
        }

        const heightOfElement: number = targetElement!.scrollHeight;
        const topOfElement: number = window.scrollY;
        const clientHeightOfElement: number = targetElement!.clientHeight;
        const bottomOffset = 100;

        if (heightOfElement <= topOfElement + clientHeightOfElement + bottomOffset) {
          this.loadMoreProduct();
        }
      },
      changeHashtagOption(selectedIndex: number): void {
        this.$router.replace(new NamedRouting('ProductListView', {}, {hashTag: selectedIndex})).catch(() => this.loadNewProduct());
      },
      loadNewProduct(): void {
        // this.products.splice(0, this.products.length);
        if (this.isLoading) {
          return;
        }
        this.isLoading = true;
        this.page = 1;
        this.hasMorePage = true;

        let idListOfSelectedHashtag = [];
        // 특정 해시태그가 선택된 경우(전체x)
        if (this.indexOfSelectedHashtag != 0) {
          idListOfSelectedHashtag.push(this.hashtagList[this.indexOfSelectedHashtag].id);
        }
        const sortBy = this.getSortOptionValue;
        const request = new GetProductRequest(this.page, this.perPage, idListOfSelectedHashtag, sortBy);

        api.getProductsByHashtag(request).then(response => {
          this.totalCount = response.data.result.totalCount;
          this.products = response.data.result.productList.map(product => new Product(product));

          if (response.data.result.productList.length < this.perPage) {
            this.hasMorePage = false;
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        })
        .finally(() => {
          this.isLoading = false;
        });
      },
      loadMoreProduct(): void {
        if (!this.hasMorePage || this.isLoading) {
          return;
        }
        this.isLoading = true;

        this.page += 1;

        let selectedHashtagIds;
        if (this.hashtagList[0].isSelected) {
          selectedHashtagIds = this.hashtagList.filter(hashtag => hashtag.id != -1).map(hashtag => hashtag.id);
        } else {
          selectedHashtagIds = this.hashtagList.filter(hashtag => hashtag.isSelected).map(hashtag => hashtag.id);
        }
        const sortBy = this.getSortOptionValue;
        const request = new GetProductRequest(this.page, this.perPage, selectedHashtagIds, sortBy);

        api.getProductsByHashtag(request).then(response => {
          this.totalCount = response.data.result.totalCount;
          response.data.result.productList.forEach(product => {
            this.products.push(new Product(product));
          });

          if (response.data.result.productList.length < this.perPage) {
            this.hasMorePage = false;
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        })
        .finally(() => {
          this.isLoading = false;
        });
      },
      ...mapMutations('SortOptionStore', [
        'initSortOption',
      ]),
    }
  });
